module.exports = __webpack_public_path__ + "static/2nd_Banner_MiniPies-769a1a33edda26b3623fd7b4e212b778.jpg";